import i18nFactory from '@yandex-int/i18n';
import { compact } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';
import { Shape2Icon } from '../../Shape2/Shape2';
import { ScopedTooltip } from '../../TooltipDecorator/ScopedTooltip';
import { PhrasesSelectorStartWordActions } from '../PhrasesSelectorStartWordActions/PhrasesSelectorStartWordActions';

import './PhrasesSelectorStartWord.css';
import * as keyset from './PhrasesSelectorStartWord.i18n';
const i18n = i18nFactory(keyset);

export interface PhrasesSelectorStartWordProps {
    isShowMinusWordAdd: boolean;
    word: string;
    onMinusWordAdd: (word: string) => void;
}

const BLOCK = 'phrases-selector-start-word';

export const PhrasesSelectorStartWord = React.memo(
    ({ isShowMinusWordAdd, word, onMinusWordAdd }: PhrasesSelectorStartWordProps) => {
        const [isTooltipVisible, changeVisibility] = useState(false);
        const tooltipAnchor = useRef(null);
        const closeTooltip = useCallback(() => changeVisibility(false), []);
        const openTooltip = useCallback(() => changeVisibility(true), []);
        const addMinusWord = useCallback((minusWord: string) => {
            onMinusWordAdd(minusWord);

            closeTooltip();
        }, []);

        useEffect(() => {
            if (!isTooltipVisible) {
                return;
            }

            window.addEventListener('wheel', closeTooltip, {
                once: true,
                capture: true
            });
        }, [isTooltipVisible]);

        const wordActions = compact([
            isShowMinusWordAdd && {
                icon: Shape2Icon.minus,
                text: i18n('add-minus-word'),
                handler: () => addMinusWord(word)
            }
        ]);
        const hasActions = wordActions.length !== 0;

        return (
            <>
                <ScopedTooltip
                    anchor={tooltipAnchor.current}
                    theme="promo"
                    view="classic"
                    tone="default"
                    to="top"
                    size="m"
                    visible={isTooltipVisible}
                    autoclosable={true}
                    onOutsideClick={closeTooltip}
                >
                    <PhrasesSelectorStartWordActions actions={wordActions} />
                </ScopedTooltip>
                {!hasActions ? (
                    <span
                        className={Bem.cls({
                            block: BLOCK
                        })}
                    >
                        {word}
                    </span>
                ) : (
                    <span
                        className={Bem.cls({
                            block: BLOCK,
                            mods: {
                                selected: isTooltipVisible,
                                'has-actions': hasActions
                            }
                        })}
                        ref={tooltipAnchor}
                        onClick={openTooltip}
                    >
                        {word}
                    </span>
                )}
            </>
        );
    }
);
